module.exports = __webpack_public_path__ + "static/media/catapult-app.a6b8eafd.png";